export default "__VITE_ASSET__Di6Gf6XP__"